module.exports = __webpack_public_path__ + "static/media/musicology-white.360e2ced.svg";